import { Grid, IconButton, Typography } from '@mui/material';
import { Icon } from '@elements';
import close from '@images/delete.svg';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

/**
 * PopupTitleSlot component.
 *
 * @author Mikhail Siutsou
 * @function PopupTitle
 * @category components
 * @param {PopupFooterProps} content props.
 * @return {JSX.Element} PopupTitleSlot component.
 */
var PopupTitle = function PopupTitle(_ref) {
  var _popUp$data;

  var children = _ref.children,
      handleClose = _ref.handleClose,
      popUp = _ref.popUp;
  var titleContent = typeof children === 'string' ? /*#__PURE__*/_jsx(Typography, {
    variant: "body1",
    fontWeight: 700,
    component: "p",
    color: "mineshaft",
    textAlign: "center",
    children: children
  }) : children;
  return /*#__PURE__*/_jsxs(Grid, {
    container: true,
    flexWrap: "nowrap",
    alignItems: "center",
    justifyContent: "space-between",
    columnSpacing: 1,
    position: "relative",
    children: [/*#__PURE__*/_jsx(Grid, {
      item: true,
      width: "100%",
      alignItems: "center",
      display: typeof children === 'string' ? 'unset' : 'flex',
      children: titleContent
    }), (popUp === null || popUp === void 0 ? void 0 : (_popUp$data = popUp.data) === null || _popUp$data === void 0 ? void 0 : _popUp$data.isShowCloseButton) && /*#__PURE__*/_jsx(Grid, {
      item: true,
      position: "absolute",
      right: "-3%",
      top: "-26%",
      children: /*#__PURE__*/_jsx(IconButton, {
        onClick: handleClose,
        size: "small",
        children: /*#__PURE__*/_jsx(Icon, {
          src: close,
          width: 24,
          height: 24,
          color: "comet"
        })
      })
    })]
  });
};

PopupTitle.displayName = 'PopupTitle';
export { PopupTitle };